<script>
    export let options;

    import { createEventDispatcher } from 'svelte';

    import OrganizationsService from "../services/organizations.service";

    let selectedDay = 1;
    const dispatch = createEventDispatcher();

    function dayChanged() {
		dispatch('dayChanged', {
			day: selectedDay
		});
    }

    function selectDay(day){
        selectedDay = day;
        jQuery('#changeDayConfirmation').modal('show');
    }

    async function updateDay(){
        let result = null;
        try {
            result = await OrganizationsService.updateWeekStartDay({"week_start_day":selectedDay}, options.org.id);
        } catch (e) {

        }

        if (result && result.data ){
            options.org = result.data;
            dayChanged();
            jQuery('#changeDayConfirmation').modal('hide');
        }
    }

    let weekdays = [
        { 'number': 1, 'name': 'Monday' },
        { 'number': 2, 'name': 'Tuesday' },
        { 'number': 3, 'name': 'Wednesday' },
        { 'number': 4, 'name': 'Thursday' },
        { 'number': 5, 'name': 'Friday' },
        { 'number': 6, 'name': 'Saturday' },
        { 'number': 7, 'name': 'Sunday' }
    ];
</script>

<div class="modal fade" id="changeDayConfirmation" tabindex="-1" role="dialog" aria-labelledby="changeDayConfirmation" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addEmployeeLabel">
                    <i class="text-danger fa fa-exclamation-triangle ml-1"></i> WARNING!
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Modifying the ending day will affect all data previously entered.</p>
                <p>Please confirm to update the ending day to <b class="text-primary">{weekdays[selectedDay - 1].name}</b> for <b class="text-primary">{options.org.name}</b>?</p>
            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                <button type="button" class="btn btn-danger " on:click={() => updateDay()} >
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

<div class="col-md-1 mt-3 p-0">
    <div class="dropdown" id="day-selector" >
        <button class="btn dropdown-toggle dropdown-date-selector" type="button" id="dropdownWeekDay" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            { options && options.org && options.org.week_start_day? weekdays[options.org.week_start_day - 1].name: ''}
        </button>
        <div class="dropdown-menu mw-100" aria-labelledby="dropdownWeekDay">
            {#each weekdays as weekday}
            <button on:click={ () => selectDay(weekday.number) } class="dropdown-item">
                {weekday.name}
            </button>
            {/each}
        </div>
    </div>
</div>
